import "./Footer.css";
import SocialMediaButtons from "../../common/SocialMediaButtons/SocialMediaButtons";
import { useTranslation } from "react-i18next";
import OptimizedImage  from "../../common/OptimizedImage/OptimizedImage";

export default function Footer() {
  const { t } = useTranslation('common');
  
  const menu = t('menu', { returnObjects: true }) || {};
  const footer = t('footer', { returnObjects: true }) || {};

  return (
    <footer className="footer">
      <div className="footer-columns">
        <div className="footer-col">
          <h4>AIVHY</h4>
          <a className="footer-link" href="/">Home</a>
          <a className="footer-link" href="/about">{menu.about}</a>
          <a className="footer-link" href="/contact-us">{menu.contact}</a>
          <a className="footer-link" href="/articles">{menu.articles}</a>
          <a className="footer-link" href="/jobs">{menu.jobs}</a>
        </div>
        <div className="footer-col">
          <h4>{footer.columns?.services?.title}</h4>
          <a className="footer-link" href="/solutions/kickstarter">{menu.kickstarter}</a>
          <a className="footer-link" href="/solutions/implementation">{menu.implementation}</a>
          <a className="footer-link" href="/solutions/consultancy">{menu.consultancy}</a>
          <a className="footer-link" href="/support">{menu.support}</a>
        </div>
        <div className="footer-col">
          <h4>{footer.columns?.expertise?.title}</h4>
          <a className="footer-link" href="/expertise/industrial4-0">{menu.industrial4}</a>
          <a className="footer-link" href="/expertise/iiot">{menu.iiot}</a>
          <a className="footer-link" href="/expertise/cyber-security">{menu.cyberSecurity}</a>
        </div>
      </div>
      <div className="footer-middle-bar">
        <div className="footer-center-text">
          <span><strong>Aivhy Netherlands</strong></span><br />
          <span>Capitool 10</span><br />
          <span>7521 PL Enschede</span><br />
          <span>Netherlands</span><br />
          <br /><span><strong>Aivhy Malta</strong></span><br />
          <span>Soho office The Strand</span><br />
          <span>Fawwara Building</span><br />
          <span>Msida road</span><br />
          <span>Gzira GZR 1401 Malta</span><br />
          <br /><span><strong>NL</strong> +31 (0)53 234 0017</span><br />
          <span><strong>MT</strong> +356 216 690 36</span><br />
          <span>info@aivhy.com</span><br />
          <span>info@aivhy.nl</span>
        </div>
        <div className="awards-logos-wrapper">
          <OptimizedImage
            src="/images/logos/MBA.webp"
            alt="2025 Industry 4.0 Innovation Award"
            className="award-logo"
            loading="lazy"
          />
        </div>
      </div>
      <div className="footer-bottom">
        <div>&copy; {new Date().getFullYear()} – Aivhy Ltd | <a href="/privacy-policy" className="text-link" style={{ fontWeight: "500"}}>Privacy</a></div>
        <SocialMediaButtons color={"#565656"}/>
      </div>
    </footer>
  );
};